import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import "../../geometry.js";
import t from "../../core/Handles.js";
import { isSome as i, abortMaybe as s, isNone as r, destroyMaybe as o } from "../../core/maybe.js";
import { property as n } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as a } from "../../core/accessorSupport/decorators/subclass.js";
import h from "./DrawAction.js";
import { DrawTool as d } from "./DrawTool.js";
import { VertexAddEvent as p, CursorUpdateEvent as _, DrawCompleteEvent as l } from "./input/DrawEvents.js";
import { createViewAlignedCoordinateSystem as c } from "./support/surfaceCoordinateSystems.js";
import { ViewEventPriorities as m } from "../input/InputManager.js";
import { SKETCH_KEYS as g } from "../interactive/keybindings.js";
import { EditGeometry as v, Component as w } from "../interactive/editGeometry/EditGeometry.js";
import { EditGeometryOperations as u } from "../interactive/editGeometry/EditGeometryOperations.js";
import { createScreenPointFromEvent as T } from "../support/screenUtils.js";
import y from "../../geometry/Point.js";
var P = ["freehand", "click"];

var k = /*#__PURE__*/function (_h) {
  _inherits(k, _h);

  var _super = _createSuper(k);

  function k(e) {
    var _this;

    _classCallCheck(this, k);

    _this = _super.call(this, e), _this._isDragging = !1, _this._panEnabled = !1, _this._viewHandles = new t(), _this._activePointerId = null, _this._addVertexOnPointerUp = !1, _this.viewAlignedCoordinateSystem = null, _this.mode = "freehand";
    return _this;
  }

  _createClass(k, [{
    key: "initialize",
    value: function initialize() {
      "2d" === this.view.type ? this._addViewHandles() : this._addDrawTool(this.view);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      "2d" === this.view.type ? (this._removeViewHandles(), this._viewHandles.destroy()) : this._removeDrawTool(), this.emit("destroy");
    }
  }, {
    key: "complete",
    value: function complete() {
      "2d" === this.view.type ? this._completeDrawing() : this._drawTool.completeCreateOperation();
    }
  }, {
    key: "getGeometryZValue",
    value: function getGeometryZValue() {
      return this.vertices.length > 0 && this.vertices[0].length > 2 ? this.vertices[0][2] : this._get("defaultZ");
    }
  }, {
    key: "_addViewHandles",
    value: function _addViewHandles() {
      this._removeViewHandles(), "click" === this.mode ? this._viewHandles.add(this._getClickModeViewHandles()) : this._viewHandles.add(this._getDragModeViewHandles());
    }
  }, {
    key: "_getDragModeViewHandles",
    value: function _getDragModeViewHandles() {
      var _this2 = this;

      return [this.view.on("immediate-click", function (e) {
        if (e.stopPropagation(), e.mapPoint && !_this2._panEnabled) {
          var _t = _this2.getCoordsFromScreenPoint(T(e));

          i(_t) && (_this2._vertexAddHandler(e), _this2._drawCompleteHandler(e));
        }
      }, m.TOOL), this.view.on("pointer-down", function (e) {
        _this2._shouldHandlePointerEvent(e) && (_this2._snappingTask = s(_this2._snappingTask), _this2._panEnabled || (_this2._resetGeometry(), _this2._addVertexOnPointerUp = !0, _this2._cursorScreenPoint = T(e), _this2._activePointerId = e.pointerId, _this2._vertexAddHandler(e), _this2._isDragging = !1, "touch" === e.pointerType && _this2._updateCursor(e.native)));
      }, m.TOOL), this.view.on("pointer-move", function (e) {
        _this2._snappingTask = s(_this2._snappingTask), r(_this2._activePointerId) && "touch" !== e.pointerType && (_this2._cursorScreenPoint = T(e), _this2._updateCursor(e.native));
      }, m.TOOL), this.view.on("pointer-drag", function (e) {
        _this2._shouldHandlePointerEvent(e) && (_this2._snappingTask = s(_this2._snappingTask), _this2._isDragging = !0, _this2._cursorScreenPoint = T(e), _this2._updateCursor(e.native));
      }, m.TOOL), this.view.on("pointer-up", function (e) {
        _this2._shouldHandlePointerEvent(e) && _this2._addVertexOnPointerUp && (_this2._snappingTask = s(_this2._snappingTask), _this2._activePointerId = null, _this2._isDragging && _this2._vertexAddHandler(e), 2 === _this2._committedVertices.length && _this2._drawCompleteHandler(e), _this2._isDragging = !1);
      }, m.TOOL), this.view.on("key-down", function (e) {
        e.key === g.complete && _this2._cursorScreenPoint ? (_this2._snappingTask = s(_this2._snappingTask), _this2._vertexAddHandler(e), _this2._drawCompleteHandler(e)) : e.key === g.pan && (_this2._panEnabled = !0);
      }, m.TOOL), this.view.on("key-up", function (e) {
        e.key === g.pan && (_this2._panEnabled = !1);
      }, m.TOOL), this.view.on("drag", function (e) {
        i(_this2._activePointerId) && e.stopPropagation();
      }, m.TOOL), this.view.on("drag", ["Shift"], function (e) {
        e.stopPropagation();
      }, m.TOOL)];
    }
  }, {
    key: "_getClickModeViewHandles",
    value: function _getClickModeViewHandles() {
      var _this3 = this;

      return [this.view.on("pointer-down", function (e) {
        _this3._snappingTask = s(_this3._snappingTask), _this3._cursorScreenPoint = T(e), _this3._activePointerId = e.pointerId, _this3._isDragging = !1, "touch" === e.pointerType && _this3._updateCursor(e.native);
      }, m.TOOL), this.view.on("pointer-move", function (e) {
        _this3._snappingTask = s(_this3._snappingTask), _this3._cursorScreenPoint = T(e), r(_this3._activePointerId) && "touch" !== e.pointerType && _this3._updateCursor(e.native);
      }, m.TOOL), this.view.on("pointer-drag", function (e) {
        _this3._shouldHandlePointerEvent(e) && (_this3._snappingTask = s(_this3._snappingTask), _this3._isDragging = !0);
      }, m.TOOL), this.view.on("pointer-up", function (e) {
        _this3._shouldHandlePointerEvent(e) && (_this3._snappingTask = s(_this3._snappingTask), _this3._activePointerId = null, e.stopPropagation(), _this3._isDragging || _this3._vertexAddHandler(e), 2 !== _this3.vertices.length || _this3._isDragging || _this3._drawCompleteHandler(e), _this3._isDragging = !1);
      }, m.TOOL), this.view.on("key-down", function (e) {
        e.key === g.vertexAdd && _this3._cursorScreenPoint && (_this3._vertexAddHandler(e), 2 === _this3.vertices.length && _this3._drawCompleteHandler(e)), e.key === g.complete && _this3._cursorScreenPoint && 2 === _this3.vertices.length && (_this3._vertexAddHandler(e), _this3._drawCompleteHandler(e));
      }, m.TOOL)];
    }
  }, {
    key: "_removeViewHandles",
    value: function _removeViewHandles() {
      this._viewHandles.removeAll();
    }
  }, {
    key: "_addDrawTool",
    value: function _addDrawTool(e) {
      var _this4 = this;

      this._drawTool = new d({
        view: e,
        elevationInfo: this.elevationInfo,
        hasZ: this.hasZ,
        geometryType: "segment",
        mode: this.mode
      }), this.view.addAndActivateTool(this._drawTool), this._drawTool.on("vertex-add", function (e) {
        1 === e.vertices.length && _this4.emit("vertex-add", new p(_this4.view, null, e.vertices[0].vertexIndex, _this4._drawTool.getVertexCoords()));
      }), this._drawTool.on("cursor-update", function (e) {
        1 === e.vertices.length && _this4.emit("cursor-update", new _(_this4.view, null, e.vertices[0].vertexIndex, _this4._drawTool.getVertexCoords()));
      }), this._drawTool.on("complete", function (e) {
        _this4.emit("draw-complete", new l(null, _this4._drawTool.getVertexCoords())), _this4._removeDrawTool();
      });
    }
  }, {
    key: "_removeDrawTool",
    value: function _removeDrawTool() {
      this.view.tools.remove(this._drawTool), this._drawTool = o(this._drawTool);
    }
  }, {
    key: "_addVertex",
    value: function _addVertex(e, t) {
      var i = this._coordinateHelper.arrayToVector(e);

      if (this._isDuplicateOfLastVertex(i)) return;
      this._lastVertexUnsnapped = this._stagedVertexUnsnapped, this._popCursorVertex(), this._editGeometryOperations.appendVertex(i), 1 === this._committedVertices.length && (this.viewAlignedCoordinateSystem = c(this.view, this._committedVertices[0]));
      var s = this._committedVertices.length - 1,
          r = new p(this.view, t, s, this.vertices);
      this.emit("vertex-add", r);
    }
  }, {
    key: "_updateCursor",
    value: function _updateCursor(e) {
      var _this5 = this;

      if (this._popCursorVertex(), !this._cursorScreenPoint) return;
      var t = this.getCoordsAndPointFromScreenPoint(this._cursorScreenPoint);

      if (i(t)) {
        this._pushCursorVertex(t.vertex);

        var _s = function _s() {
          return new _(_this5.view, e, _this5._activeComponent.vertices.length, _this5.vertices, i(_this5._stagedVertex) ? new y(_this5._stagedVertex) : null);
        };

        this.emit("cursor-update", _s()), i(this._snappingTask) && this._snappingTask.promise.then(function (e) {
          e.valid && _this5.emit("cursor-update", _s());
        }, function () {});
      }
    }
  }, {
    key: "_completeDrawing",
    value: function _completeDrawing(e) {
      if (this._activePointerId = null, this._popCursorVertex(), this._cursorScreenPoint = null, this._isDragging = !1, this._snappingTask = s(this._snappingTask), i(this._snappingManager) && this._snappingManager.doneSnapping(), this.vertices.length < 1) return;
      var t = new l(e, this.vertices);
      this.emit("draw-complete", t), t.defaultPrevented || this._removeViewHandles();
    }
  }, {
    key: "_resetGeometry",
    value: function _resetGeometry() {
      this._editGeometryOperations.destroy(), this._editGeometryOperations = new u(new v("polygon", this._coordinateHelper, 2)), this._activeComponent = new w(this._coordinateHelper.spatialReference, 2), this._editGeometryOperations.data.components.push(this._activeComponent);
    }
  }, {
    key: "_shouldHandlePointerEvent",
    value: function _shouldHandlePointerEvent(e) {
      return H(e) && (r(this._activePointerId) || this._activePointerId === e.pointerId);
    }
  }]);

  return k;
}(h);

function H(e) {
  return "mouse" !== e.pointerType || 0 === e.button;
}

e([n({
  type: P
})], k.prototype, "mode", void 0), k = e([a("esri/views/2d/engine/markup/SegmentDrawAction")], k);
export { k as SegmentDrawAction };